import React, { useState, useEffect } from 'react';
import { Mail, Link2, Check, Share2, TrendingUp } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import { SHARE_CONTENT, getWeeklyThread } from '../../data/shareContent';
import { trackEvent } from '../../lib/analytics';
import { SITE_URL } from '../../lib/siteConfig';
import { toast } from 'sonner';

const SHARE_ORIGIN = SITE_URL;
const BACKEND = process.env.REACT_APP_BACKEND_URL;
const enc = encodeURIComponent;
const hstr = (h) => h.map((t) => `#${t}`).join(' ');

const G = ({ d, ...p }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="h-[18px] w-[18px]" aria-hidden="true" {...p}><path d={d} /></svg>
);

const GLYPH = {
  linkedin: <G d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />,
  facebook: <G d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />,
  x: <G d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z" />,
  whatsapp: <G d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />,
  viber: <G d="M11.398.002C9.473.028 5.331.344 3.014 2.467 1.294 4.177.687 6.7.625 9.815c-.061 3.116-.072 8.95 5.557 10.516v2.42s-.036.974.609 1.17c.778.232 1.234-.535 1.962-1.345.4-.448.948-1.106 1.36-1.594 3.836.318 6.776-.42 7.11-.532.776-.26 5.16-.84 5.872-6.704.736-6.044-.348-9.87-2.32-11.59l-.005-.003c-.612-.563-3.022-2.476-7.27-2.49 0 0-.5-.034-1.502-.034l.07.001zM7.97 9.48c-.025-.488.71-.55.736-.062.06 1.225-.55 1.65-1.5 1.6-.487-.025-.426-.76.062-.737.5.026.71-.213.702-.8zm.16-2.69c1.74.013 3.18 1.21 3.32 3.42.03.49-.71.55-.736.06-.114-1.79-1.18-2.71-2.6-2.74-.488-.012-.45-.748.016-.74zm1.4-1.84c2.74.022 4.97 1.93 5.06 5.18.013.49-.726.51-.738.02-.082-2.86-2.01-4.45-4.34-4.46-.488-.004-.46-.745.018-.74z" />,
  telegram: <G d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.139-5.061 3.345-.479.329-.913.489-1.302.481-.428-.009-1.252-.242-1.865-.442-.751-.244-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />,
};

const PLATFORMS = [
  { id: 'linkedin', label: 'LinkedIn', brand: '#0A66C2', build: (u, c, h) => `https://www.linkedin.com/sharing/share-offsite/?url=${enc(u)}` },
  { id: 'facebook', label: 'Facebook', brand: '#1877F2', build: (u, c, h) => `https://www.facebook.com/sharer/sharer.php?u=${enc(u)}&quote=${enc(`${c}\n\n${hstr(h)}`)}&hashtag=${enc('#BoneFiller')}` },
  { id: 'x', label: 'X', brand: '#0f172a', build: (u, c, h) => `https://twitter.com/intent/tweet?text=${enc(c)}` },
  { id: 'whatsapp', label: 'WhatsApp', brand: '#25D366', build: (u, c, h) => `https://wa.me/?text=${enc(`${c}\n\n${u}\n\n${hstr(h)}`)}` },
  { id: 'viber', label: 'Viber', brand: '#7360F2', build: (u, c, h) => `viber://forward?text=${enc(`${c} ${u} ${hstr(h)}`)}` },
  { id: 'telegram', label: 'Telegram', brand: '#229ED9', build: (u, c, h) => `https://t.me/share/url?url=${enc(u)}&text=${enc(`${c}\n\n${hstr(h)}`)}` },
];

// Link-preview crawlers that read Open Graph tags -> point at the backend OG
// endpoint (/api/share/:page) so each shared page shows a TAILORED card instead
// of the generic site-wide homepage preview (SPA limitation).
const OG_PLATFORMS = new Set(['linkedin', 'facebook', 'x', 'whatsapp', 'telegram']);

const SocialShare = ({ pageKey, accent = '#3b82f6' }) => {
  const { theme } = useTheme();
  const dark = theme !== 'light';
  const data = SHARE_CONTENT[pageKey];
  const [caption] = useState(() => (data ? data.captions[Math.floor(Math.random() * data.captions.length)] : ''));
  const xThread = getWeeklyThread();
  const [copied, setCopied] = useState(false);
  const [notice, setNotice] = useState('');
  const [fbText, setFbText] = useState('');
  const [count, setCount] = useState(null);

  useEffect(() => {
    if (!BACKEND || !data) return;
    let active = true;
    fetch(`${BACKEND}/api/share/stats`)
      .then((r) => r.json())
      .then((stats) => { if (active) setCount(stats[pageKey] || 0); })
      .catch(() => {});
    return () => { active = false; };
  }, [pageKey, data]);

  if (!data) return null;
  const pageUrl = `${SHARE_ORIGIN}${data.path}`;
  const ogUrl = `${SHARE_ORIGIN}/api/share/${pageKey}`;
  const hashtags = data.hashtags;

  const track = (method) => {
    trackEvent('share_click', { method, page: pageKey });
    if (BACKEND) {
      fetch(`${BACKEND}/api/share/track`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ page: pageKey, method }),
        keepalive: true,
      }).catch(() => {});
      setCount((c) => (c === null ? 1 : c + 1));
    }
  };

  // Robust clipboard write that never throws: tries the async Clipboard API
  // (often blocked by iframe permissions-policy) and falls back to execCommand,
  // returning true/false so callers can show an appropriate notice.
  const legacyCopy = (text) => {
    try {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.top = '-9999px';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      const ok = document.execCommand('copy');
      document.body.removeChild(ta);
      return ok;
    } catch (e) {
      return false;
    }
  };

  const writeClipboard = (text, onResult) => {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        const p = navigator.clipboard.writeText(text);
        if (p && typeof p.then === 'function') {
          p.then(() => onResult && onResult(true)).catch(() => onResult && onResult(legacyCopy(text)));
          return;
        }
        onResult && onResult(true);
        return;
      }
    } catch (e) { /* fall through to legacy */ }
    onResult && onResult(legacyCopy(text));
  };

  const copy = () => {
    writeClipboard(`${caption}\n\n${pageUrl}\n\n${hstr(hashtags)}`, (ok) => {
      if (ok) toast.success('Caption & link copied to clipboard', { description: 'Paste it into a post or message to share with a colleague.' });
    });
    setCopied(true);
    track('copy');
    setTimeout(() => setCopied(false), 2200);
  };

  // Facebook strips pre-filled post text (platform policy), so on FB share we
  // copy the full caption + hashtag-heavy set to the clipboard for one-paste posting.
  const copyForFacebook = () => {
    const text = `${caption}\n\n${hstr(hashtags)}\n\n${pageUrl}`;
    writeClipboard(text, (ok) => {
      if (ok) toast.success('Caption & hashtags copied to clipboard', { description: 'Paste them into your Facebook post.' });
      setNotice(ok
        ? 'Caption + hashtags copied — paste them into your Facebook post.'
        : 'Copy the caption + hashtags below and paste them into your Facebook post:');
      setFbText(ok ? '' : text);
      setTimeout(() => { setNotice(''); setFbText(''); }, 12000);
    });
  };

  const surface = dark ? 'border-white/10 bg-slate-900/60' : 'border-slate-200 bg-white';
  const btnBase = dark ? 'border-slate-700 bg-slate-800/80 text-slate-300' : 'border-slate-200 bg-slate-50 text-slate-600';
  const hover = (id, b) => (id === 'x' ? (dark ? '#e7e9ea' : '#0f172a') : b);

  return (
    <div data-testid={`social-share-${pageKey}`} className={`rounded-2xl border p-5 sm:p-6 ${surface}`}>
      <div className="flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-3 text-left">
          <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-xl" style={{ backgroundColor: `${accent}1f`, color: accent }}>
            <Share2 className="h-4 w-4" strokeWidth={2} />
          </span>
          <div>
            <p className={`text-sm font-black tracking-tight ${dark ? 'text-white' : 'text-slate-900'}`}>Share the science with a colleague</p>
            <p className="mt-0.5 text-xs leading-relaxed text-slate-500">Captions &amp; hashtags are pre-written — one tap to post.</p>
            {count >= 5 && (
              <span data-testid="share-count-badge" className="mt-2 inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-bold" style={{ backgroundColor: `${accent}1f`, color: accent }}>
                <TrendingUp className="h-3 w-3" strokeWidth={2.4} /> Shared {count}× by colleagues
              </span>
            )}
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-2">
          {PLATFORMS.map((p) => (
            <a
              key={p.id}
              href={p.build(OG_PLATFORMS.has(p.id) ? ogUrl : pageUrl, p.id === 'x' ? xThread : caption, hashtags)}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => { track(p.id); if (p.id === 'facebook') copyForFacebook(); }}
              aria-label={`Share on ${p.label}`}
              data-testid={`share-${p.id}`}
              style={{ '--bc': hover(p.id, p.brand) }}
              className={`flex h-10 w-10 items-center justify-center rounded-xl border transition-all duration-200 hover:-translate-y-0.5 hover:text-[var(--bc)] hover:border-[var(--bc)] ${btnBase}`}
            >
              {GLYPH[p.id]}
            </a>
          ))}
          <a
            href={`mailto:?subject=${enc(data.title)}&body=${enc(`${caption}\n\n${pageUrl}\n\n${hstr(hashtags)}`)}`}
            onClick={() => track('email')}
            aria-label="Share via Email"
            data-testid="share-email"
            style={{ '--bc': accent }}
            className={`flex h-10 w-10 items-center justify-center rounded-xl border transition-all duration-200 hover:-translate-y-0.5 hover:text-[var(--bc)] hover:border-[var(--bc)] ${btnBase}`}
          >
            <Mail className="h-[18px] w-[18px]" strokeWidth={2} />
          </a>
          <button
            onClick={copy}
            aria-label="Copy link and caption"
            data-testid="share-copy"
            style={{ '--bc': accent }}
            className={`flex h-10 w-10 items-center justify-center rounded-xl border transition-all duration-200 hover:-translate-y-0.5 hover:text-[var(--bc)] hover:border-[var(--bc)] ${btnBase}`}
          >
            {copied ? <Check className="h-[18px] w-[18px] text-green-500" strokeWidth={2.4} /> : <Link2 className="h-[18px] w-[18px]" strokeWidth={2} />}
          </button>
        </div>
      </div>
      {notice && (
        <div data-testid="share-fb-notice" className="mt-4 rounded-lg border border-dashed px-3 py-2" style={{ borderColor: `${accent}66`, color: accent, backgroundColor: `${accent}12` }}>
          <p className="text-[11px] font-semibold">{notice}</p>
          {fbText && (
            <textarea
              readOnly
              value={fbText}
              data-testid="share-fb-fallback-text"
              onFocus={(e) => e.target.select()}
              rows={4}
              className="mt-2 w-full resize-none rounded-md border border-slate-600 bg-slate-900/80 p-2 text-[11px] leading-relaxed text-slate-200"
            />
          )}
        </div>
      )}
    </div>
  );
};

export default SocialShare;
